"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

/**
 * A class to represent the the options that are passed to the MwChartWordCloudChartOptions.onPointClick
 * @param {object} options - Not neeeded externally
 *
 * @property {number} key - The word value
 * @property {string} seriesName - The name of the series
 * @property {string} value - The weight value
 *
 */
var MwChartWordCloudClickOptions = function MwChartWordCloudClickOptions(_ref) {
  var name = _ref.name,
      series = _ref.series,
      weight = _ref.weight;
  (0, _classCallCheck2.default)(this, MwChartWordCloudClickOptions);
  this.key = name;
  this.seriesName = series.name;
  this.value = weight;
  Object.freeze(this);
};

exports.default = MwChartWordCloudClickOptions;